import { useQuery } from '@tanstack/react-query'

import type { Pass } from '../types/pass'

import { api } from '@/shared/services/api'

export function usePasses() {
  return useQuery({
    queryKey: ['/user/passes'],
    queryFn: async () => {
      const { data } = await api.get<{ records: Pass[] }>('/user/passes')
      return data.records
    }
  })
}
